module.exports = __webpack_public_path__ + "ba326423188ed0ee81f180ab46858479.svg";